import { ITableConfig } from "@/components/table/table.model";
import { SORTING_DIR } from "@/common/models";

export const table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "",
      sortable: false,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "3rem",
      spanMax: "3rem",
    },
    {
      name: "Folder Name",
      key: "name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "15rem",
      spanMax: "1fr",
    },
    {
      name: "Path",
      key: "path",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "20rem",
      spanMax: "1.5fr",
    },
    {
      name: "Investigate",
      key: "investigate",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "10rem",
    },
  ],
};
